require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/core-js/modules/es7.symbol.observable.js
// module id = ../../node_modules/core-js/modules/es7.symbol.observable.js
// module chunks = 18